export interface TokenResponse {
  sub: string;
  account_id: string;
  first_name: string;
  last_name: string;
  person_id: string;
  error: string;
  error_description: string;
}
